import { createFileRoute } from "@tanstack/react-router";
import { AuthenticateWithRedirectCallback } from "@clerk/tanstack-react-start";
import { z } from "zod";
import { normalizeAppPath } from "~/lib/security";

const searchSchema = z.object({
	redirect: z.string().optional(),
});

export const Route = createFileRoute("/sso-callback")({
	validateSearch: (search) => {
		const parsed = searchSchema.parse(search);
		return parsed.redirect === undefined
			? {}
			: { redirect: normalizeAppPath(parsed.redirect) };
	},
	component: () => <SSOComponent />,
});

function SSOComponent() {
	const { redirect } = Route.useSearch();
	const redirectUrl = redirect ?? "/dashboard";

	return (
		<div className="flex min-h-[calc(100vh-4rem)] flex-col items-center justify-center gap-4">
			<div id="clerk-captcha" />
			<div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
			<p className="text-sm text-muted-foreground">We're verifying your identity, this shouldn't take long.</p>
			<AuthenticateWithRedirectCallback
				signInForceRedirectUrl={redirectUrl}
				signUpForceRedirectUrl={redirectUrl}
			/>
		</div>
	);
}
